import { render, staticRenderFns } from "./TaskV2.vue?vue&type=template&id=5f50bfeb&scoped=true"
import script from "./TaskV2.vue?vue&type=script&lang=js"
export * from "./TaskV2.vue?vue&type=script&lang=js"
import style0 from "./TaskV2.vue?vue&type=style&index=0&id=5f50bfeb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f50bfeb",
  null
  
)

export default component.exports